import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'




export default class SensorButtons extends Component {

    constructor(props) {
        super(props)
        this.state = {
            arrLength: this.props.button.length
        }
    }


    render() {
        const { bgcolor, heading, button } = this.props
        const { arrLength } = this.state

        return (
            <Wrapper bgcolor={bgcolor}>
                <HeroWrapper fluid>
                    <Row alignItems={'center'}>
                        {button.map((button, index) => {
                            return (
                                <Col key={index} md={arrLength < 3 ? 6 : 4} xs={6} sm={6} style={colStyle}>
                                    <CardContainer to={getRelativeUrl(button.link_to.link)}>
                                        <Uppertext>{button.text}</Uppertext>
                                        <ImgContainer>
                                            <Img img={button.image.sourceUrl} className={'icon'} />
                                        </ImgContainer>
                                    </CardContainer>
                                </Col>
                            )
                        })}
                    </Row>
                </HeroWrapper>
            </Wrapper>
        )
    }
}

const colStyle = {
    marginTop: '10px'
}

const Wrapper = styled.div`
  margin-bottom: 65px;
  background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
  padding: 30px 0;
  `


const HeroWrapper = styled(Container)`
                    padding: 0 20px;
                    ${media.lg`
                    padding: 0 20%;
                    `}
                    `


const CardContainer = styled(Link)`
:hover .icon {
    transform: scale(1.1);
}
`
const ImgContainer = styled.div`
overflow: hidden;
position: relative;
border-left: 1px solid ${theme.colors.tones.lighter};
border-bottom: 1px solid ${theme.colors.tones.lighter};
border-right: 1px solid ${theme.colors.tones.lighter};
`
const Img = styled.div`
width: 100%;
padding-top: 70%;
background-color: white;
background-size: contain;
background-position: center;
background-repeat: no-repeat;
background-image: url('${props => props.img}');
margin: auto;
transition: all 0.25s ease;

${media.md`
padding-top: 30%;
`}
`
const Uppertext = styled.div`
height: 60px;
text-align: center;
background-color: white;
padding: 20px 20px 0px 20px;
color: #004077;
text-transform: uppercase;
font-size: 3vw;
font-weight: 700;
border-left: 1px solid ${theme.colors.tones.lighter};
border-top: 1px solid ${theme.colors.tones.lighter};
border-right: 1px solid ${theme.colors.tones.lighter};
${media.md`
font-size: 1.5vw;
padding: 20px;
height: 100px;
`}

${media.lg`
font-size: 0.8vw;
`}



`


// WEBPACK FOOTER //
// ./src/ui/components/modules/SensorButtons/index.js